export default __webpack_public_path__ + "static/media/barbarian_icon.1fc3b23a.png";